const getModifiedSavedSearches = (savedSearchResults) => {
  return savedSearchResults.map((item) => {
    item.query = item.title;
    return item;
  });
};

export default getModifiedSavedSearches;
